import { render, staticRenderFns } from "./whiteboard.vue?vue&type=template&id=5e571b9d&scoped=true&"
import script from "./whiteboard.vue?vue&type=script&lang=js&"
export * from "./whiteboard.vue?vue&type=script&lang=js&"
import style0 from "./whiteboard.vue?vue&type=style&index=0&id=5e571b9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e571b9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
